import ReactGA from 'react-ga';
import { IS_DEVEL } from 'client/constants';
import debug from 'debug';

const log = debug('app:client:analytics');
let options = {};

if (IS_DEVEL) {
	options = { debug: false };
}

export const tracker = {
	init: function init(id) {
		if (typeof window === 'undefined') {
			return;
		}
		if (!id) {
			console.warn('There is no google analytics ID.');
			return;
		}
		log('init', id);
		ReactGA.initialize(id, options);
	},
	pageview: function pageview(...args) {
		log('pageview', ...args);
		ReactGA.pageview(...args);
	},
	event: function event(...args) {
		log('event', ...args);
		ReactGA.event(...args);
	},
	ga: function ga(args) {
		log('ga', ...args);
		ReactGA.ga(...args);
	},
};

export function track({ type, payload }) {
	try {
		tracker[type](payload);
	} catch (error) {
		if (IS_DEVEL) {
			console.warn('Failed to track analytics event', error);
		}
	}
}

export const dataLayerEvents = {
	onNavItemClick: title => {
		track({
			type: 'event',
			payload: { category: 'Navigation Menu', action: title, label: 'Navigation_Events' },
		});

		// window.dataLayer.push({
		// 	event: 'Navigation_Events',
		// 	Category: 'Navigation Menu',
		// 	Action: title,
		// 	Label: '',
		// });
	},
	onShareClick: type => {
		track({
			type: 'event',
			payload: { category: 'Social - Share', action: type, label: '' },
		});

		// window.dataLayer.push({
		// 	event: 'Share_Events',
		// 	Category: 'Social - Share',
		// 	Action: type,
		// 	Label: '',
		// }),
	},
	onCVBtnClick: btnPlace => {
		track({
			type: 'event',
			payload: { category: 'CV Form Submission Clicked', action: btnPlace, label: '' },
		});

		// window.dataLayer.push({
		// 	event: 'Form_Events',
		// 	Category: 'CV Form Submission Clicked',
		// 	Action: btnPlace,
		// 	Label: '',
		// }),
	},
	onAccessibilityClick: () => {
		track({
			type: 'event',
			payload: { category: 'Accessibility', action: 'Accessibility Clicked', label: '' },
		});

		// window.dataLayer.push({
		// 	event: 'Accessibility',
		// 	Category: 'Accessibility',
		// 	Action: 'Accessibility Clicked',
		// 	Label: '',
		// }),
	},
	// podcasts events
	audioPlayerEvents: (type, podcastTitle) => {
		track({
			type: 'event',
			payload: { category: 'Audio', action: type, label: podcastTitle },
		});

		// window.dataLayer.push({
		// 	event: 'Audio_events',
		// 	Category: 'Audio',
		// 	Action: type,
		// 	Label: podcastTitle,
		// }),
	},
	podcastPercents: (percentage, podcastTitle) => {
		track({
			type: 'event',
			payload: { category: 'Audio', action: `Played ${percentage}`, label: podcastTitle },
		});

		// window.dataLayer.push({
		// 	event: 'Audio_events',
		// 	Category: 'Audio',
		// 	Action: `Played ${percentage}`, // 25% / 50% / 75% / 90% / 100%
		// 	Label: podcastTitle,
		// }),
	},
	pageView: (url, podcastTitle) => {
		track({
			type: 'ga',
			payload: ['send', 'pageview', { page: url.substr(url.indexOf('#') + 1), title: podcastTitle }],
		});

		// window.dataLayer.push({
		// 	event: 'virtualPageview',
		// 	virtualPageURL: url,
		// 	virtualPageTitle: podcastTitle,
		// }),
	},
};
